import {css, SerializedStyles} from "@emotion/react";

type MethodStyled = 'every' | 'some'

const styledIf = (method: MethodStyled, condition?: boolean) => (val1: string, template: SerializedStyles) => (props: any) => {
  return Boolean(props[val1]) === condition && template
};

const is = styledIf('every', true);

const isNot = styledIf('every', false);

const isOr = styledIf('some', true);

const isSomeNot = styledIf('some', false);

const matchIf = () => <T, P extends keyof T>(key: P, value: T[P], template: SerializedStyles) => (props: any) => {
  return props[key] === value && css(template)
}
const match = matchIf()

const matchProps = <T>() => <P extends keyof T>(key: P, value: T[P], template: (SerializedStyles | any)) => (props: any) => {
  return props[key] === value && template
}

export {isNot, isOr, is, isSomeNot, match, matchProps};